module.exports = __webpack_public_path__ + "img/message-x-square.a739b107.svg";